import { render } from "./AddGroupDialog.vue?vue&type=template&id=e530083c"
import script from "./AddGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddGroupDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__